import { SVGProps } from 'react';

const MapScaleSmall = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_3_463)">
            <path
                d="M5.33341 12L0.666748 14.6667V4.00001L5.33341 1.33334M5.33341 12L10.6667 14.6667M5.33341 12V1.33334M10.6667 14.6667L15.3334 12V1.33334L10.6667 4.00001M10.6667 14.6667V4.00001M10.6667 4.00001L5.33341 1.33334"
                stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                strokeWidth={1.33333}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_3_463">
                <rect width={16} height={16} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default MapScaleSmall;
